module.exports = __webpack_public_path__ + "static/media/camera-gallery.f4505ddb.svg";